module.exports = __webpack_public_path__ + "img/exhaustPipe-2.0088ccff.jpg";